import { DeclarationHighValueGroupType } from '@e-origin/shared';

import { Variant } from '../types';

const H2 = DeclarationHighValueGroupType.H2;

export const beExport: Variant = {
  'goodShipmentGlobal.customsProcedureType': { present: true },
  'goodShipmentGlobal.customsNationalProcedure': { present: true },
  'goodShipmentGlobal.customsNationalProcedureCode': { present: true },

  'messageInfo.methodOfPayment': { amendmentLocked: true },
  'messageInfo.deferredPayment': { amendmentLocked: true },
  'messageInfo.methodOfPaymentVAT': { amendmentLocked: true },
  'messageInfo.security': { present: true },

  // Only `section` moves - base's own `rules: [B2B_NOT_H2]` already governs presence (B2B, not H2)
  // for every context; repeating a `{txClass: B2B}`-only rule here would drop the H2 exclusion.
  'valuationInformationTaxes.deliveryTerms.incotermCode': { section: 'customs' },
  'valuationInformationTaxes.deliveryTerms.location': { section: 'customs' },
  'valuationInformationTaxes.deliveryTerms.country': { section: 'customs' },

  'consignment.countryOfExport': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'consignment.carrier': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'consignment.countryOfDestination': { code: 'CL008' },

  'consignment.customsOfficeExit.referenceNumber': { present: true },
  'consignment.customsOfficeExport.referenceNumber': { present: true },
  'consignment.customsSupervisingOffice.referenceNumber': { amendmentLocked: true },
  'consignment.customsOfficePresentation.referenceNumber': { present: true, code: 'CL193' },

  'messageInfo.declarationMainType': { amendmentLocked: true },
  'messageInfo.declarationType': { amendmentLocked: true },
  customer: { amendmentLocked: true },

  'transportInformation.departureTransportMeans.identificationNumber': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'transportInformation.departureTransportMeans.typeOfIdentification': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'transportInformation.departureTransportMeans.nationality': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'transportInformation.activeBorderTransportMeans.identificationNumber': { present: true },
  'transportInformation.activeBorderTransportMeans.typeOfIdentification': { present: true },
  'transportInformation.countryOfRoutingOfConsignment': { present: true },
  'transportInformation.modeOfTransportMeansAtTheBorder': { rules: [{ when: { group: H2 }, then: { present: false } }] },
};
